// Lazy loading locales
export default {
	loadLanguageAsync (lang) {
		return import(`@/i18n/${lang}.json`).then(msgs => {
			return Promise.resolve(msgs)
		})
	}
}
